import React from 'react';
import SocialIcons from './social-icons';
import SupportDetails from './support-details';
function ConnectionDetails() {
  return <div className='order-1 col-span-full flex h-full flex-col justify-center gap-6 lg:order-2 lg:col-span-1' data-sentry-component="ConnectionDetails" data-sentry-source-file="connection-details.tsx">
            <SupportDetails data-sentry-element="SupportDetails" data-sentry-source-file="connection-details.tsx" />
            <SocialIcons className='border-t border-text-darkGray pt-6 lg:border-none lg:pt-4' data-sentry-element="SocialIcons" data-sentry-source-file="connection-details.tsx" />
        </div>;
}
export default ConnectionDetails;